import { useLocation, useNavigate, useSearchParams, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import PageSelector from '../../components/PageSelector';
import LoadingPage from "../../components/Loading";
import DropdownMenu from './components/Dropdown'
import MDEditor from '@uiw/react-md-editor';
import _, { set, times, wrap } from 'lodash';
import { HexColorPicker } from "react-colorful";
import RemoveSvg from '../../svgs/RemoveSvg'
import FileDropzone from '../../components/FileDropzone'
import { uploadPhoto } from "../../services/documents";
import { deletePartner, fetchPartnerById, updatePartner } from "../../services/partners";
import ContentEditor from './components/ContentEditor'
import { fetchPromotions } from "../../services/promotions";
import PartnerAccountManagement from "./components/PartnerAccountManagement";
import PartnerTShopProducts from "./components/PartnerTShopProducts";
import ConciergePreview from "./components/ConciergePreview";
import TshopPreview from "./components/TshopPreview";
import RefreshButton from '../../svgs/RefreshButton'
import SaveButton from '../../svgs/SaveButton'
import TshopRefundManagement from "./components/TshopRefundManagement";
import PartnerFinance from './PartnerFinance'
import PartnerPostManagement from "./components/PartnerPostManagement";

const TABS = ['合作夥伴管理', '生活服務',
    //'生活服務-優惠券', 
    '生活服務預覽', 'T.Shop', 'T.Shop 商品', 'T.Shop預覽', '關於我們', '條款及細則', '管理員', '財務報告', '商品退款管理', '貼文管理'];

function Page(props) {
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();
    const navigateTo = (str) => () => {
        navigate(str)
    }
    const [isloading, setIsloading] = useState(false)
    const [searchParams, setSearchParams] = useSearchParams();

    const [data, setData] = useState({})
    useEffect(() => {
        fetchData()
    }, [props.token])

    async function fetchData() {
        let res = await fetchPartnerById(id)
        if (res.result) {
            setData(res.result)
        }
    }
    const refresh = async () => {
        fetchData()
    }

    function handleParamChange(key, val) {
        searchParams.delete(key)
        if (val !== '') searchParams.set(key, val)
        setSearchParams(searchParams)
    }

    const onDropImageFile = (field) => async (files) => {
        if (files.length > 1) {
            alert(`Only one file is allowed.`)
            return
        }
        const file = files[0]
        if (!['image/png', 'image/jpeg', 'image/gif'].includes(file.type)) {
            alert(`File type ${file.type} is not allowed`)
            return
        }
        if (file.size > 1024 * 1024 * 5) {
            alert(`File size must be within 5 MB`)
            return
        }

        let formData = new FormData();
        formData.append('file', file, file.name);
        formData.append('json', JSON.stringify({}));

        setIsloading(true);
        let res = await uploadPhoto(props.token?.token, formData, id, `${field}_${Math.floor(Math.random() * 1000)}`)
        if (res.errno) {
            alert(res.message || '上傳失敗')
        } else {
            if (res.result) {
                let filepath = res.result
                await updatePartner(props.token?.token, id, { [field]: filepath });
                setData({ ...data, [field]: filepath })
            }
        }
        setIsloading(false);
    }
    const onDropHerosImageFile = async (files) => {
        if (files.length > 1) {
            alert(`Only one file is allowed.`)
            return
        }
        const file = files[0]
        if (!['image/png', 'image/jpeg', 'image/gif'].includes(file.type)) {
            alert(`File type ${file.type} is not allowed`)
            return
        }
        if (file.size > 1024 * 1024 * 5) {
            alert(`File size must be within 5 MB`)
            return
        }

        let formData = new FormData();
        formData.append('file', file, file.name);
        formData.append('json', JSON.stringify({}));

        setIsloading(true);
        let res = await uploadPhoto(props.token?.token, formData, id, `heros_${data.heros?.length + 1}`)
        if (res.errno) {
            alert(res.message || '上傳失敗')
        } else {
            if (res.result) {
                let filepath = res.result
                await updatePartner(props.token?.token, id, { heros: [...(data.heros || []), filepath] });
                setData({ ...data, heros: [...(data.heros || []), filepath] })
            }
        }
        setIsloading(false);
    }
    const save = async () => {
        if (!data.name || data.name.length < 3) {
            alert('合作夥伴名稱長度需大於3')
            return
        }
        setIsloading(true)
        let res = await updatePartner(props.token?.token, id, {
            name: data.name,
            status: data.status,
            order: data.order,
            isNew: !!data.isNew,
            category: data.category || [],
            thumbnail: data.thumbnail || null,
            hero: data.hero || null,
            contentTitle: data.contentTitle || "",
            isTshopRecommended: !!data.isTshopRecommended,
            isTshopWeeklyPopular: !!data.isTshopWeeklyPopular,
            isTshopTopViews: !!data.isTshopTopViews,
            isTshopMostFavourited: !!data.isTshopMostFavourited,
            heros: data.heros || [],
            hero2: data.hero2 || null,
            tags: data.tags || [],
            promotions: data.promotions || [],
        });
        if (res.errno) {
            alert(res.message || '更新失敗')
        } else {
            alert('更新成功')
            refresh()
        }
        setIsloading(false);
    }




    const [tab, setTab] = useState(TABS[0])


    const [promotionList, setPromotionList] = useState([])
    async function fetchPromotionList() {
        let res = await fetchPromotions({}, { limit: 999 }, { name: 1 })
        if (res.errno) return
        if (res.result)
            setPromotionList(res.result)
    }
    useEffect(() => {
        fetchPromotionList()
    }, [])



    {/*introduction handler*/ }
    const handleContentOrder = (field) => (oldLayout, newLayout) => {
        let array = []
        newLayout.sort((a, b) => { if (a.y < b.y) { return -1; } else if (b.y < a.y) { return 1; } return 0; })
        for (let i of newLayout) {
            let oldIndex = _.findIndex(oldLayout, { 'i': i.i });
            array.push(data[field][oldIndex]);
        }
        let d = { ...data };
        d[field] = array;
        setData(d);
    }
    const handleAddContent = (field) => () => {
        let d = { ...data };
        let c = [...(d[field] || [])]
        c.push({ id: Date.now(), type: 'text', data: '', isTitle: false })
        d[field] = c
        setData(d);
    }
    const handleSectionDeleteContent = (field) => (card, cardIndex) => {
        let d = { ...data }
        let c = d?.[field] || [];
        c.splice(cardIndex, 1);
        d[field] = c;
        setData(d)
    }
    const handleSectionEditContent = (field) => (card, cardIndex, key, value) => {
        let d = { ...data };
        d[field][cardIndex][key] = value
        setData(d);
    }
    {/*introduction handler*/ }

    const [newTag, setNewTag] = useState('')
    const [newPromotion, setNewPromotion] = useState('')
    const [isDeleting, setIsDeleting] = useState(false)
    const onDelete = async () => {
        setIsloading(true)
        let res = await deletePartner(props.token?.token, id)
        if (res.errno) {
            alert(res.message || '刪除失敗')
            setIsloading(false)
        } else {
            alert('刪除成功')
            navigate('/cms/partners')
        }
    }

    return (
        <div className="relative h-full w-full flex flex-col items-start justify-start bg-[#ddd] pb-[16px] gap-[16px]" style={{ overflowY: 'auto' }}>

            <div className='p-[16px] relative rounded-[7px] w-full p-[16px] z-[2] flex flex-row'>
                <div className="flex flex-col z-[2]">
                    <div className="font-[700] text-[24px]">{data.name}</div>
                    <div className="text-[12px]">合作夥伴管理 {'>'} {data.name}</div>
                </div>
                <div className="flex flex-row  flex-1 items-center justify-end gap-[8px] z-[2]">
                    <div onClick={save} className="cursor-pointer hover:opacity-[.5]">
                        <SaveButton />
                    </div>
                    <div onClick={refresh} className="cursor-pointer hover:opacity-[.5]">
                        <RefreshButton />
                    </div>
                    <div onClick={() => { setIsDeleting(true) }} className="cursor-pointer hover:opacity-[.5] text-white font-[700] text-[22px] px-[12px] py-[4px] rounded-[8px]" style={{ background: 'linear-gradient(180deg, #8C706B 0%, rgba(140, 112, 107, 0.2) 100%)' }}>
                        刪除
                    </div>
                </div>
                <div className="absolute w-full bottom-0 left-0 right-0 top-0" style={{ background: 'linear-gradient(180deg, rgba(255, 255, 255, 0) 69%, rgba(255, 255, 255, 0.6) 87.5%, #FFFFFF 100%)', zIndex: 1 }} />
            </div>
            <div className="w-full flex flex-row gap-[16px] flex-wrap px-[16px]" style={{ borderBottom: '2px solid #fff' }}>
                {TABS.map((item, index) =>
                    <div key={item} className="flex flex-row items-center justify-center cursor-pointer mb-[-2px]" style={{ fontWeight: item === tab ? '700' : '400', fontSize: '16px', color: item === tab ? '#0F737E' : '#00000099', padding: '8px 16px', borderBottom: item === tab ? '2px solid #0F737E' : 'none' }} onClick={() => { setTab(item) }}>
                        {item}
                    </div>
                )}
            </div>

            {tab === '合作夥伴管理' && <div className="w-full flex flex-col gap-[16px] p-[16px]">
                <div className="w-full gap-[16px] flex flex-row items-start justify-start flex-wrap">
                    <div className='flex-1 flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start mt-[8px]'>
                        <div className='font-[700]'>合作夥伴名稱</div>
                        <input value={data?.name || ''} onChange={(e) => { setData({ ...data, name: e.target.value }) }} placeholder='活動名稱' className='rounded-[7px] px-[8px] py-[4px] font-[400]' />
                    </div>
                    <div className='flex-1 flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start mt-[8px]'>
                        <div className='font-[700]'>活動狀態</div>
                        <DropdownMenu options={['已公開', '草稿']}
                            value={data?.status === 'published' ? '已公開' : '草稿'}
                            select={(item, index) => {
                                setData({ ...data, status: item === '已公開' ? 'published' : 'draft' })
                            }}
                        />
                    </div>
                    <div className='flex-1 flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start mt-[8px]'>
                        <div className='font-[700]'> 顯示順序（數值越大，顯示越前）</div>
                        <input value={data?.order ?? ''} type="number" onChange={(e) => {
                            let num = parseInt(e.target.value) ?? 99
                            setData({ ...data, order: num < 0 ? 0 : num })
                        }} placeholder='顯示順序' className='rounded-[7px] px-[8px] py-[4px] font-[400]' />
                    </div>
                    {/* <div className='w-full flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start mt-[8px]'>
                        <div className='font-[700]'>推薦活動</div>
                        <DropdownMenu options={['是', '否']}
                            value={data?.isRecommended ? '是' : '否'}
                            select={(item, index) => {
                                setData({ ...data, isRecommended: item === '是' })
                            }}
                        />
                    </div> */}
                </div>
                <div className='w-full flex flex-col max-w-[600px] min-w-[400px] gap-[8px] mt-[8px]'>
                    <div className='font-[700]'>封面圖片</div>
                    <div className="w-full flex flex-row gap-[8px]">
                        {data?.thumbnail && <div className='relative w-full'>
                            {
                                data?.thumbnail
                                    ? <img style={{ height: 'auto', width: '100%', objectFit: 'contain' }} src={data?.thumbnail} alt='image' />
                                    : <div>
                                    </div>
                            }
                            <div onClick={() => { setData({ ...data, thumbnail: '' }) }} className='cursor-pointer' style={{ position: 'absolute', top: 5, right: 5 }}>
                                <RemoveSvg />
                            </div>
                        </div>}
                        <div className='w-full' style={{ height: 170, backgroundColor: 'white', border: '1px solid #E5E5E5' }}>
                            <FileDropzone onDropFile={onDropImageFile('thumbnail')} data={data} />
                        </div>
                    </div>
                </div>
                {/* <div className="flex flex-row items-center justify-start w-full gap-[16px] mt-[24px]">
                    <div onClick={save} className="cursor-pointer text-[#6E604C] text-[16px] font-[700] py-[4px] px-[24px] rounded-[4px] bg-[#6E604C20] hover:opacity-80 items-center flex flex-row" style={{ border: '1px solid #6E604C' }}>
                        儲存
                    </div>
                    <div onClick={refresh} className="cursor-pointer text-[#000] text-[16px] font-[700] py-[4px] px-[24px] rounded-[4px] bg-[#ccc] hover:opacity-80 items-center flex flex-row" style={{ border: '1px solid #000' }}>
                        重新整理
                    </div>
                </div> */}
            </div>}

            {tab === '生活服務' && <div className="w-full flex flex-col gap-[16px] p-[16px]">
                <div className="w-full gap-[16px] flex flex-row items-start justify-start flex-wrap">

                    <div className='flex-1 flex flex-row gap-[8px] max-w-[300px] min-w-[300px] justify-start mt-[8px] items-center'>
                        <div className='font-[700]'>最新生活服務夥伴</div>
                        <DropdownMenu options={['是', '否']}
                            value={data?.isNew ? '是' : '否'}
                            select={(item, index) => { setData({ ...data, isNew: item === '是' }) }}
                        />
                    </div>
                    <div className='flex-1 flex flex-row gap-[8px] max-w-[660px] min-w-[560px] justify-start mt-[8px] items-center'>
                        <div className='font-[700] mx-[24px]'>類別</div>
                        <div className="flex flex-row gap-[8px] flex-wrap">
                            {[
                                { label: '住宿', type: 'accommodation' },
                                { label: '餐飲', type: 'food' },
                                { label: '交通', type: 'travel' },
                                { label: '購物', type: 'shopping' },
                                { label: '醫療', type: 'medical' },
                                { label: '教育', type: 'education' },
                            ]?.map((item, index) =>
                                <div key={index} onClick={() => {
                                    let category = data?.category || []
                                    if (category.includes(item.type)) {
                                        category = category.filter((type) => type !== item.type)
                                    } else {
                                        category.push(item.type)
                                    }
                                    setData({ ...data, category })
                                }} className="cursor-pointer text-[16px] font-[700] py-[4px] px-[24px] rounded-[4px] items-center flex flex-row" style={{ background: data?.category?.includes(item.type) ? 'linear-gradient(180deg, #8C866B 0%, rgba(140, 134, 107, 0.2) 100%)' : 'linear-gradient(180deg, #A9A9A9 0%, rgba(198, 198, 198, 0.2) 100%)', color: data?.category?.includes(item.type) ? 'white' : 'black', opacity: data?.category?.includes(item.type) ? 1 : 0.5 }}>
                                    {item.label}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className='w-full flex flex-col max-w-[600px] min-w-[400px] gap-[8px] mt-[8px]'>
                    <div className='font-[700]'>頂部圖片</div>
                    <div className="w-full flex flex-row gap-[8px]">
                        {data?.hero && <div className='relative w-full'>
                            {
                                data?.hero
                                    ? <img style={{ height: 'auto', width: '100%', objectFit: 'contain' }} src={data?.hero} alt='image' />
                                    : <div>
                                    </div>
                            }
                            <div onClick={() => { setData({ ...data, hero: '' }) }} className='cursor-pointer' style={{ position: 'absolute', top: 5, right: 5 }}>
                                <RemoveSvg />
                            </div>
                        </div>}
                        <div className='w-full' style={{ height: 170, backgroundColor: 'white', border: '1px solid #E5E5E5' }}>
                            <FileDropzone onDropFile={onDropImageFile('hero')} data={data} />
                        </div>
                    </div>
                </div>

                <div className='w-full flex flex-col gap-[8px] mt-[64px]'>
                    <div className='font-[700]'>相關優惠</div>
                    {data?.promotions.length === 0 && <div className='text-[12px] text-[#00000099]'>請選擇優惠</div>}
                    <div className="w-full flex flex-row gap-[8px] flex-wrap">
                        {data?.promotions?.map((item, index) =>
                            <div key={item} className="flex flex-row items-center justify-between gap-[8px] mt-[8px]">
                                <div className='w-full flex flex-row max-w-[600px] min-w-[400px] gap-[24px] items-center border-[1px] border-[#6E604C80] rounded-[99px] p-[24px]'>
                                    {promotionList?.filter((p) => p._id === item)?.[0]?.name}
                                    <div className="cursor-pointer" onClick={() => {
                                        let promotions = [...(data.promotions || [])]
                                        promotions.splice(index, 1)
                                        setData({ ...data, promotions })
                                    }}>
                                        X
                                    </div>
                                </div>

                            </div>
                        )}
                    </div>
                    <div className="font-[700] mt-[8px]">添加相關優惠文章</div>
                    <div className='w-full flex flex-row flex-wrap gap-[8px] mt-[8px] items-center'>
                        <DropdownMenu options={promotionList?.map((item) => item.name)}
                            value={newPromotion || "請選擇優惠"}
                            style={{ backgroundColor: '#fff', padding: '16px', minWidth: '400px' }}
                            select={(item, index) => { setNewPromotion(item) }}
                        />
                        <div onClick={() => {
                            if (newPromotion) {
                                let promotions = [...(data.promotions || [])]
                                promotions.push(promotionList?.filter((p) => p.name === newPromotion)?.[0]?._id)
                                setData({ ...data, promotions })
                                setNewPromotion('')
                            }
                        }} className="cursor-pointer text-[white] text-[16px] py-[4px] px-[24px] rounded-[4px] bg-[#0F737E] hover:opacity-80 items-center flex flex-row">
                            + 添加
                        </div>
                    </div>

                </div>


                {/* <div className="flex flex-row items-center justify-start w-full gap-[16px] mt-[64px] mb-[100px]">
                    <div onClick={save} className="cursor-pointer text-[#6E604C] text-[16px] font-[700] py-[4px] px-[24px] rounded-[4px] bg-[#6E604C20] hover:opacity-80 items-center flex flex-row" style={{ border: '1px solid #6E604C' }}>
                        儲存
                    </div>
                    <div onClick={refresh} className="cursor-pointer text-[#000] text-[16px] font-[700] py-[4px] px-[24px] rounded-[4px] bg-[#ccc] hover:opacity-80 items-center flex flex-row" style={{ border: '1px solid #000' }}>
                        重新整理
                    </div>
                </div> */}
            </div>}

            {tab === 'T.Shop' && <div className="w-full flex flex-col gap-[16px] p-[16px]">
                <div className="w-full gap-[16px] flex flex-row items-start justify-start flex-wrap">
                    {[
                        { label: '為您推薦', field: 'isTshopRecommended' },
                        { label: '每週熱門', field: 'isTshopWeeklyPopular' },
                        { label: '最高瀏覽', field: 'isTshopTopViews' },
                        { label: '最多收藏', field: 'isTshopMostFavourited' },
                    ]?.map((item, index) => <div key={index} className='flex-1 flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start mt-[8px]'>
                        <div key={item?.label} className='font-[700]'>{item?.label}</div>
                        <DropdownMenu options={['是', '否']}
                            value={data?.[item.field] ? '是' : '否'}
                            select={(o, oi) => { setData({ ...data, [item.field]: o === '是' }) }}
                        />

                    </div>)}
                </div>

                <div className='font-[700] mt-[16px] flex flex-row flex-wrap gap-[16px] flex items-center justify-start'>
                    產品類別
                </div>
                <div className='w-full flex flex-row min-w-[200px] gap-[8px] flex-wrap items-center'>
                    {data?.tags?.map((item, index) => <div key={item + index} className='w-full flex flex-row max-w-[200px] min-w-[200px] gap-[8px] items-center'>
                        {Number(index) + 1}.
                        <div className="text-[16px] font-[700] py-[4px] px-[24px] rounded-[4px] items-center flex flex-row" style={{ border: '1px solid #000', backgroundColor: '#ccc', color: 'black' }}>{item}</div>
                        <div className="cursor-pointer" onClick={
                            () => {
                                let tags = [...(data.tags || [])]
                                tags.splice(index, 1)
                                setData({ ...data, tags })
                            }
                        }><RemoveSvg /></div>
                    </div>
                    )}
                </div>
                <div className='w-full flex flex-row gap-[8px] mt-[8px] items-center'>
                    <input value={newTag || ''} onChange={(e) => { setNewTag(e.target.value) }} placeholder='新增產品類別' className='rounded-[7px] px-[8px] py-[4px] font-[400]' />
                    <div onClick={() => {
                        if (newTag) {
                            let tags = [...(data.tags || [])]
                            tags.push(newTag)
                            setData({ ...data, tags })
                            setNewTag('')
                        }
                    }} className="cursor-pointer text-[#6E604C] text-[16px] font-[700] py-[4px] px-[24px] rounded-[4px] bg-[#6E604C20] hover:opacity-80 items-center flex flex-row" style={{ border: '1px solid #6E604C' }}>
                        新增
                    </div>
                </div>

                <div className='font-[700] mt-[64px] flex flex-row flex-wrap gap-[16px] flex items-center justify-start'>
                    頂部照片輪播 (推薦比例: 431:149) [請一次上傳一張圖片]
                </div>
                <div className='w-full flex flex-row max-w-[1000px] min-w-[200px] gap-[8px] flex-wrap'>
                    {data?.heros?.map((item, index) => <div key={index} className='w-full flex flex-col max-w-[300px] min-w-[300px] gap-[8px]'>
                        <div className=''>照片{Number(index) + 1}:</div>
                        {item && <div className='relative w-full'>
                            {
                                item
                                    ? <img style={{ height: 'auto', width: '100%', objectFit: 'contain' }} src={item} alt='image' />
                                    : <div>
                                    </div>
                            }
                            <div onClick={() => {
                                let heros = [...(data.heros || [])]
                                heros.splice(index, 1)
                                setData({ ...data, heros })
                            }} className='cursor-pointer' style={{ position: 'absolute', top: 5, right: 5 }}>
                                <RemoveSvg />
                            </div>
                        </div>}
                    </div>)}
                    <div className='w-full max-w-[300px]' style={{ height: 170, backgroundColor: 'white', border: '1px solid #E5E5E5' }}>
                        <FileDropzone onDropFile={onDropHerosImageFile} data={data} />
                    </div>
                </div>



                <div className='w-full flex flex-col max-w-[600px] min-w-[400px] gap-[8px] mt-[64px]'>
                    <div className='font-[700]'>頁面中間圖片 (推薦比例: 430:242)</div>
                    <div className="w-full flex flex-row gap-[8px]">
                        {data?.hero2 && <div className='relative w-full'>
                            {
                                data?.hero2
                                    ? <img style={{ height: 'auto', width: '100%', objectFit: 'contain' }} src={data?.hero2} alt='image' />
                                    : <div>
                                    </div>
                            }
                            <div onClick={() => { setData({ ...data, hero2: '' }) }} className='cursor-pointer' style={{ position: 'absolute', top: 5, right: 5 }}>
                                <RemoveSvg />
                            </div>
                        </div>}
                        <div className='w-full' style={{ height: 170, backgroundColor: 'white', border: '1px solid #E5E5E5' }}>
                            <FileDropzone onDropFile={onDropImageFile('hero2')} data={data} />
                        </div>
                    </div>
                </div>


                {/* <div className="flex flex-row items-center justify-start w-full gap-[16px] mt-[24px]">
                    <div onClick={save} className="cursor-pointer text-[#6E604C] text-[16px] font-[700] py-[4px] px-[24px] rounded-[4px] bg-[#6E604C20] hover:opacity-80 items-center flex flex-row" style={{ border: '1px solid #6E604C' }}>
                        儲存
                    </div>
                    <div onClick={refresh} className="cursor-pointer text-[#000] text-[16px] font-[700] py-[4px] px-[24px] rounded-[4px] bg-[#ccc] hover:opacity-80 items-center flex flex-row" style={{ border: '1px solid #000' }}>
                        重新整理
                    </div>
                </div> */}
            </div>
            }

            {tab === 'T.Shop 商品' && <PartnerTShopProducts partner={data} />}
            {tab === '關於我們' && <div className="w-full flex flex-col gap-[16px] p-[16px]">
                <div className='flex-1 flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start mt-[8px]'>
                    <div className='font-[700]'>關於我們-標題</div>
                    <input value={data?.contentTitle || ''} onChange={(e) => { setData({ ...data, contentTitle: e.target.value }) }} placeholder='關於我們標題' className='rounded-[7px] px-[8px] py-[4px] font-[400]' />
                </div>
                <ContentEditor
                    data={data}
                    field={'content'}
                    refresh={refresh}
                    onDelete={handleSectionDeleteContent('content')}
                    onAddCard={handleAddContent('content')}
                    onEditKey={handleSectionEditContent('content')}
                    updateOrder={handleContentOrder('content')}
                    updateContentTitle={true}
                />
            </div>}
            {tab === '條款及細則' && <ContentEditor
                data={data}
                field={'termsAndConditions'}
                refresh={refresh}
                onDelete={handleSectionDeleteContent('termsAndConditions')}
                onAddCard={handleAddContent('termsAndConditions')}
                onEditKey={handleSectionEditContent('termsAndConditions')}
                updateOrder={handleContentOrder('termsAndConditions')}
            />}
            {tab === '管理員' && <PartnerAccountManagement />}
            {tab === '生活服務預覽' && <ConciergePreview data={data} refresh={refresh} />}
            {tab === 'T.Shop預覽' && <TshopPreview data={data} refresh={refresh} />}
            {tab === '商品退款管理' && <TshopRefundManagement partner={data} refresh={refresh} />}
            {tab === '財務報告' && <PartnerFinance refresh={refresh} />}
            {tab === '貼文管理' && <PartnerPostManagement />}
            {tab === '生活服務-優惠券' && <div className="w-full flex flex-col gap-[16px] p-[16px]">
                Coming Soon
            </div>}


            {isDeleting && <div className="fixed top-0 left-0 right-0 bottom-0 bg-black bg-opacity-50 flex items-center justify-center z-[100]">
                <div className="bg-white p-[24px] rounded-[8px] flex flex-col items-center justify-center gap-[16px]">
                    <div className="text-[18px] font-[700]">確定要刪除這個合作夥伴嗎？</div>
                    <div className="text-[14px] text-[#00000099]">刪除後將無法恢復。</div>
                    <div className="flex flex-row gap-[16px]">
                        <div onClick={() => { setIsDeleting(false) }} className="cursor-pointer text-[#6E604C] text-[16px] font-[700] py-[4px] px-[24px] rounded-[4px] bg-[#6E604C20] hover:opacity-80 items-center flex flex-row" style={{ border: '1px solid #6E604C' }}>
                            取消
                        </div>
                        <div onClick={onDelete} className="cursor-pointer text-[red] text-[16px] font-[700] py-[4px] px-[24px] rounded-[4px] bg-[#ffcccc] hover:opacity-80 items-center flex flex-row" style={{ border: '1px solid red' }}>
                            刪除
                        </div>
                    </div>
                </div>
            </div>}
            {isloading && <LoadingPage />}
        </div>
    )
}


export default connect((store) => {
    return {
        token: store.tokenReducer,
        control: store.controlReducer,
    }
})(Page)

